import { Datagrid, List, ReferenceArrayField, ReferenceField, TextField, useRecordContext } from "react-admin";
import CustomDateField from "shared/components/fields/CustomDateField";
import { MaintenanceResourcesEnum, SiteResourcesEnum } from "shared/enums/resourceMappings";

export default function GroupMaintenances() {
  const record = useRecordContext();

  if (!record) return null;

  return (
    <List
      resource={MaintenanceResourcesEnum.Maintenance}
      filter={{
        end__gt: new Date().toISOString(),
        site_id__in: record.site_ids,
      }}
    >
      <Datagrid>
        <TextField source="id" sortable={false} />
        <CustomDateField source="start" sortable={true} showTime />
        <CustomDateField source="end" sortable={true} showTime />
        <ReferenceField source="site_id" sortable={false} reference={SiteResourcesEnum.Sites} link="show" />
        <ReferenceField
          source="site_id"
          sortable={false}
          reference={SiteResourcesEnum.Sites}
          link={false}
          label={"Groups"}
        >
          <ReferenceArrayField source="group_ids" reference={SiteResourcesEnum.Groups} filter={{ type: "rte_edr" }} />
        </ReferenceField>
        <TextField source="type" sortable={false} />
        <TextField source="operator" sortable={false} />
        <TextField source="comment" sortable={false} />
        <CustomDateField source="updated_at" sortable={false} showTime />
        <CustomDateField source="created_at" sortable={false} showTime />
      </Datagrid>
    </List>
  );
}
